let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8F6ik")).then(() => parcelRequire('f8JZq'));